import React, { useState } from "react";

const Filtersubscriptions = ({ onSearch }) => {
  const [name, setName] = useState();
  const [introducerId, setIntroducerId] = useState();
  const [amount, setAmount] = useState();
  const [shareClassType, setShareClassType] = useState();



  const handleInputChange = (e) => {
    const value = e.target.value;
    setName(value);
  };

 

  const handleInputChange2 = (e) => {
    const value = e.target.value;
    setIntroducerId(value);
  };

  const handleInputChange3 = (e) => {
    const value = e.target.value;
    setAmount(value);
  };

  const handleInputChange4 = (e) => {
    const value = e.target.value;
    setShareClassType(value);
  };  

  const handleSearchClick = () => {
    onSearch({ name,  introducerId,amount,shareClassType  });
  };

  return (
    <div>
      <div className="row ">
        <div className="col-sm-6 col-md-2">
          <input
            type="text"
            placeholder="Search by Name"
            className="form-control floating"
            value={name}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-sm-6 col-md-2">
          <input
            type="text"
            placeholder="Search by Advisor"
            className="form-control floating"
            value={introducerId}
            onChange={handleInputChange2}
          />
        </div>

        <div className="col-sm-6 col-md-2">
          <input
            type="text"
            placeholder="Search by Amount"
            className="form-control floating"
            value={amount}
            onChange={handleInputChange3}
          />
        </div>

        <div className="col-sm-6 col-md-2">
          <input
            type="text"
            placeholder="Search by ShareClass"
            className="form-control floating"
            value={shareClassType}
            onChange={handleInputChange4}
          />
        </div>

        <div className="col-sm-3 col-md-2">
          <button
            className="btn btn-primary  w-100"
            onClick={handleSearchClick}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default Filtersubscriptions;
